<template>
  <div
    id="up-navigation-sidebar-wrapper"
    class="w-18 h-screen top-0 left-0 sticky z-10 tracking-normal"
  >
    <slot />
  </div>
</template>
